import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import dedent from 'dedent';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';
import McmVirtualConfig from '~/tenants/mcm/performable/virtual/McmVirtualConfig';

const McmPackageEssential: TenantPackageConfig<McmOrderContext> = {
  id: 'essential',
  name: 'Essential',
  performables: [
    McmPhotoConfig,
    McmVirtualConfig,
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.PHOTO
      },
    },
  ],
  eligible: ({ buyer, parent }) => !Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '',
  amount: '54.95',
};

export default McmPackageEssential;
